import Vue from 'vue'
import Unicon from 'vue-unicons'
import {
  uniFilm,
  uniMap,
  uniFileAlt,
  uniCheckSquare,
  uniGlobe,
  uniSignAlt,
  uniPhone,
  uniInfoCircle,
  uniPlus,
  uniMinus,
  uniArrowLeft,
  uniAngleLeft,
  uniAngleRight,
  uniTimes,
  uniTimesCircle,
  uniSort,
  uniAngleDown,
  uniAngleUp,
  uniPlay,
  uniGrid,
  uniChart,
  uniExternalLinkAlt
} from 'vue-unicons/src/icons'

Unicon.add([
  uniFilm,
  uniMap,
  uniFileAlt,
  uniCheckSquare,
  uniGlobe,
  uniSignAlt,
  uniPhone,
  uniInfoCircle,
  uniPlus,
  uniMinus,
  uniArrowLeft,
  uniAngleLeft,
  uniAngleRight,
  uniTimes,
  uniTimesCircle,
  uniSort,
  uniAngleDown,
  uniAngleUp,
  uniPlay,
  uniGrid,
  uniChart,
  uniExternalLinkAlt
])
Vue.use(Unicon)
